export default __webpack_public_path__ + "static/commission-free-2-4bb748d3c2377a597e1919b3165d7bf5.svg";